// Components==============
import React, { createContext } from 'react';
import {
  getTranslate,
  LocalizeState,
  TranslateFunction,
} from 'react-localize-redux';
import { useSelector } from 'react-redux';
// =========================

type GlobalTranslateContextType = TranslateFunction;

export const GlobalTranslateContext = createContext(
  {} as GlobalTranslateContextType
);

export default function GlobalTranslate({
  children,
}: {
  children: React.ReactNode;
}) {
  const localizeState = useSelector(
    ({ localize }: { localize: LocalizeState }) => localize
  );

  const translate = getTranslate(localizeState);

  return (
    <GlobalTranslateContext.Provider value={translate}>
      {children}
    </GlobalTranslateContext.Provider>
  );
}
